var React = require('react');

function Megaphone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.00001 11.6667C5.92049 11.6667 6.66668 12.4129 6.66668 13.3333L6.73308 16.8615L32.4987 10.1085C32.7736 10.0365 33.0566 10 33.3407 10C35.1776 10 36.6667 11.4914 36.6667 13.3311V26.6681C36.6667 26.9527 36.6303 27.2361 36.5583 27.5114C36.0933 29.2912 34.2758 30.3564 32.4987 29.8907L6.66668 23.1377V26.6667C6.66668 27.5871 5.92049 28.3333 5.00001 28.3333C4.07954 28.3333 3.33334 27.5871 3.33334 26.6667V13.3333C3.33334 12.4129 4.07954 11.6667 5.00001 11.6667ZM10 20.574V19.4401L33.3333 13.3341V26.6667L10 20.574Z","fill":"#D33736"}));
}

Megaphone.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Megaphone;

Megaphone.default = Megaphone;
